<template>
    <div class="page-dashboard-subscription">
        <div class="page-dashboard-subscription__loader"
            v-if="isLoading"
            >
            <div class="page-dashboard-subscription__loader-container">
                <ui-loader />
            </div>
        </div>
        <div class="page-dashboard-subscription__title">
            Подписка на рассылку ПАй
        </div>
        <div class="page-dashboard-subscription__description">
            Здесь вы можете управлять подпиской на нашу рассылку.
            <br>
            <br>
            Мы бережно относимся к рассылкам и с любовью создаём каждое письмо. Подписавшись, вы будете получать только самое важное: новости, гайды и ранний доступ к распродаже.
        </div>
        <div class="page-dashboard-subscription__form">
            <ui-form
                v-bind:model="fields"
                v-bind:validation="$v"
                v-on:update="updateHandler"
                v-bind:submit-handler="submitHandler"
            />
        </div>
        <div class="page-dashboard-subscription__button">
            <ui-button
                v-on:click="submitHandler"
                v-bind:class="{ _disabled: isLoading }"
                v-bind:disabled="isLoading"
                is-uppercase
                type="submit"
                >
                подписаться
            </ui-button>
        </div>
        <div class="page-dashboard-subscription__consent">
            <ui-checkbox-consent
                v-model="consent"
                v-bind:is-error="consentError"
                is-subscribe
            />
        </div>
        <div class="page-dashboard-subscription__unsubscribe" v-on:click="unsubscribeHandler">
            Отписаться от рассылки
        </div>
        <div class="page-dashboard-subscription__result" v-if="result">
            {{ result }}
        </div>
        <div class="page-dashboard-subscription__result _error" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import forms from '~/forms';

export default {
    name: 'page-dashboard-subscription',
    data: () => ({
        fields: {
            email: { ...forms.fields.email, label: 'E-mail' },
        },
        consent: false,
        consentError: false,
        result: '',
        error: '',
    }),
    validations: {
        fields: {
            email: { ...forms.validations.email },
        },
    },
    computed: {
        ...mapState('subscription', [
            'subscribeResult',
            'subscribeIsLoading',
            'unSubscribeIsLoading',
        ]),
        isLoading() {
            return this.subscribeIsLoading || this.unSubscribeIsLoading;
        },
        user() {
            return this.$store.getters['user/user'];
        },
    },
    methods: {
        updateHandler(newData) {
            this.fields = newData;
        },
        checkConsent() {
            this.consentError = !this.consent;
        },
        submitHandler() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                this.checkConsent();
                return;
            }
            if (!this.consent) {
                this.checkConsent();
                return;
            }
            this.result = '';
            this.error = '';
            this.$store.dispatch('subscription/subscribe', {
                onSuccess: () => {
                    this.result = 'Спасибо! Вы успешно подписаны ;-)';
                },
                onError: () => {
                    this.error = 'Что-то пошло не так. Попробуйте позже';
                },
                email: this.fields.email.value.toLowerCase(),
            });
        },
        unsubscribeHandler() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                return;
            }
            this.result = '';
            this.error = '';
            this.$store.dispatch('subscription/unsubscribe', {
                onSuccess: () => {
                    this.result = 'Спасибо! Вы успешно отписаны ;-)';
                },
                onError: () => {
                    this.error = 'Что-то пошло не так. Попробуйте позже';
                },
                email: this.fields.email.value.toLowerCase(),
            });
        },
    },
    mounted() {
        this.fields.email.value = this.user.email || '';
    },
    watch: {
        consent(newVal) {
            if (newVal) {
                this.consentError = false;
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-dashboard-subscription {
    .typography-body-md();

    position: relative;

    width: 100%;
    max-width: 360px;
    padding: 0 20px;
    &__loader {
        position: absolute;
        top: 0;
        left: 0;

        display: flex;
        width: 100%;
        height: 100%;

        background: @color-gray-lightest;
        &-container {
            width: 50px;
            margin: auto;
        }
    }
    &__title {
        margin-bottom: 12px;

        text-transform: uppercase;
    }
    &__consent {
        margin-top: 12px
    }
    &__unsubscribe {
        .mixin-link-decoration();

        margin-top: 32px;
        text-transform: uppercase;
    }
    &__result {
        .typography-body-md();

        margin-top: 32px;
        color: @color-accent-cold;
        &._error {
            color: @color-accent-warm;
        }
    }
    &__description {
        margin-bottom: 36px;
    }
    &__form {
        margin-bottom: 12px;
    }
    &__button {
        height: 48px;
    }
    &__button + &__stat {
        margin-top: 32px;
    }
    &__stat {
        margin-bottom: 24px;
    }
    @media @media-xs-down {
        max-width: 100%;
    }
}
</style>
